/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface BrandAndMarketListItemFilterItemOutputWithPermission
 */
export interface BrandAndMarketListItemFilterItemOutputWithPermission {
    /**
     * 
     * @type {boolean}
     * @memberof BrandAndMarketListItemFilterItemOutputWithPermission
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandAndMarketListItemFilterItemOutputWithPermission
     */
    displayText?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BrandAndMarketListItemFilterItemOutputWithPermission
     */
    value?: BrandAndMarketListItem;
    /**
     * 
     * @type {boolean}
     * @memberof BrandAndMarketListItemFilterItemOutputWithPermission
     */
    isEffective?: boolean;
}

export function BrandAndMarketListItemFilterItemOutputWithPermissionFromJSON(json: any): BrandAndMarketListItemFilterItemOutputWithPermission {
    return BrandAndMarketListItemFilterItemOutputWithPermissionFromJSONTyped(json, false);
}

export function BrandAndMarketListItemFilterItemOutputWithPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandAndMarketListItemFilterItemOutputWithPermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : BrandAndMarketListItemFromJSON(json['value']),
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function BrandAndMarketListItemFilterItemOutputWithPermissionToJSON(value?: BrandAndMarketListItemFilterItemOutputWithPermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowEdit': value.allowEdit,
        'displayText': value.displayText,
        'value': BrandAndMarketListItemToJSON(value.value),
        'isEffective': value.isEffective,
    };
}


